import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
import routes from './routes';
import { find, omit } from 'lodash-es';
import { ROUTER_MODE } from '@star/config';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const router = createRouter({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition && !to.meta?.noCache) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            ...savedPosition,
            behavior: 'smooth',
          });
        }, 50);
      });
    }

    // 如果 path 相同，則不做任何事情
    // if (to.path === from.path) {
    //   return
    // } else {
    //   return { top: 0, behavior: 'smooth' }
    // }
  },
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  // history: createHistory(process.env.VUE_ROUTER_BASE),
  history: ROUTER_MODE === 'history' ? createWebHistory() : createWebHashHistory(),
});

const findRoute = (name: string) => {
  return omit(find(routes, { name }), ['component']) as RouteRecordRaw;
};

// trackRouter(router)
export { router, findRoute };
